export class GroupBookingGuide {

    public id?: number;
    public firstName: string;
    public lastName: string;
    public phoneNumber: string;
    public email: string;
    public address: string;

    constructor(
        firstName: string,
        lastName: string,
        phoneNumber: string,
        email: string,
        address: string
    ){
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.email = email;
        this.address = address;
    }
}
